import { IAccountsDataManager, IPostAddressBookEntriesParams, IUpdateAccountMetaInfoParams } from './iaccounts_data_managter';
import { IClientConfig } from '../data_manager/data_manager_factory';
import { AjaxHelper } from '../../http/ajax_helper';
import { IAjaxHelperConfig } from '../../http/iajax_helper_config';

export class UAAccountsManager implements IAccountsDataManager   {
    discoveryEndPoints: { libraryService: string; };
    constructor(config: IClientConfig) {
        this.discoveryEndPoints = config.discoveryEndPoints;
    }    

    postAddressBookEntries(params: IPostAddressBookEntriesParams){
      const url = '/v1/account/' + params.accountId + '/address';
      const config = {
        url: this.discoveryEndPoints.libraryService + '/request_api',
        type: "POST",
        data: JSON.stringify({uriTemplate: `/v1/account/{accountId}/address`,version: "v1", type: "POST", req_service: "accounts",url: url, data: params.data }),
        ignoreAToken:true
      }
      const promise = AjaxHelper.triggerApi({ requestConfig: config });
        
      return promise;
    }

    getAddressBookEntries(accountId: string): Promise<any> {
      const url = '/v1/account/' + accountId + '/address?queryLimit=2000';
      const config = {
        url: this.discoveryEndPoints.libraryService + '/request_api',
        type: "POST",
        data: JSON.stringify({uriTemplate: `/v1/account/{accountId}/address`,version: "v1", type: "GET", req_service: "accounts",url: url }),
        ignoreAToken:true,
        ignoreResCaching: true
      }
      const promise = AjaxHelper.triggerApi({ requestConfig: config })
    
      return promise;
    }
    updateAccountMetaInfo(params: IUpdateAccountMetaInfoParams): Promise<any> {
        const url = '/v1/account/' + params.accountId + '/globalInfo';
        const config = {
            url: this.discoveryEndPoints.libraryService + '/request_api',
            type: "POST",
            data: JSON.stringify({uriTemplate: `/v1/account/{accountId}/globalInfo`,version: "v1", type: "PUT", req_service: "accounts",url: url, data: params.data }),
            ignoreAToken:true
        }
        const promise = AjaxHelper.triggerApi({ requestConfig: config });
        
        return promise;
    }    
}